import { useNavigate } from 'react-router-dom';
import type { ListData } from '../../../types';
import BookIcon from './icons/BookIcon';

interface PlaylistChipProps {
  playlist: ListData;
}

/**
 * A compact clickable chip showing playlist name and position.
 * Used in Now Playing section and Item page when playing from a playlist.
 */
export default function PlaylistChip({ playlist }: PlaylistChipProps) {
  const navigate = useNavigate();

  const contentIds: string[] = playlist.contentIds
    ? JSON.parse(playlist.contentIds)
    : [];
  const position = playlist.playlistPosition ?? 0;
  const total = contentIds.length;

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/id/${playlist.id}`);
      }}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        gap: '4px',
        background: 'var(--teal-soft)',
        border: 'none',
        borderRadius: '12px',
        padding: '3px 8px 3px 6px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        whiteSpace: 'nowrap',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#dcecea';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--teal-soft)';
      }}
      title={`${playlist.title} - ${position + 1} of ${total}`}
    >
      <BookIcon size={12} color="var(--teal)" />
      <span
        style={{
          fontSize: '0.7rem',
          color: 'var(--teal)',
          fontWeight: 500,
          maxWidth: '100px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {playlist.title}
      </span>
      <span
        style={{
          fontSize: '0.65rem',
          color: 'var(--teal)',
          opacity: 0.8,
        }}
      >
        {position + 1}/{total}
      </span>
    </button>
  );
}
